import { api } from "@/config/axiosInstance";
import { env } from "@/config/env";
import {
  ParametrizationDataDto,
  ParametrizationIndexCreateDto,
  ParametrizationIndexPaginatedDto,
  ParametrizationIndexQueryDto,
} from "@/pages/parameterization/types";

export const useParametrization = () => {
  const getParametrizations = ({
    page,
    name,
    type,
  }: ParametrizationIndexQueryDto) => {
    let params = `page=${page}&perPage=${env.per_page}`;

    if (name) {
      params = `${params}&name=${name}`;
    }

    if (type) {
      params = `${params}&type=${type}`;
    }

    return api.get<ParametrizationIndexPaginatedDto>(
      `/parameter/index?${params}`
    );
  };

  const parametrizationCreate = (data: ParametrizationIndexCreateDto) => {
    return api.post<ParametrizationDataDto>("parameter/create", data);
  };

  const parametrizationUpdate = (
    id: number,
    data: ParametrizationIndexCreateDto
  ) => {
    return api.put<ParametrizationDataDto>(`/parameter/${id}`, data);
  };

  const parametrizationDelete = (id: number) => {
    return api.delete<void>(`/parameter/${id}`);
  };

  const getParameterByType = () => {
    return api.get<{
      branches: ParametrizationDataDto[];
      teams: ParametrizationDataDto[];
      types: ParametrizationDataDto[];
    }>("/parameter/by-type");
  };

  return {
    getParametrizations,
    parametrizationCreate,
    parametrizationDelete,
    parametrizationUpdate,
    getParameterByType,
  };
};
